import { Outlet, createFileRoute } from '@tanstack/react-router'

import { DroidMapMetadata } from '@droidmap/shared-service-contract'

export const Route = createFileRoute('/_authenticated/orgs/$orgId_/projects')({
  beforeLoad: async ({ params, context }) => {
    const { orgId } = params
    const metadata: DroidMapMetadata = {
      ...context.metadata,
      orgId,
    }
    return { metadata }
  },
  loader: async ({ params, context }) => {
    const { orgId } = params
    const { organisationClient } = context.client
    const org = await organisationClient.getOrganisation(
      { orgId },
      context.metadata,
    )
    return { crumb: org.name, orgId, org, metadata: context.metadata }
  },
  component: RouteComponent,
})

function RouteComponent() {
  return <Outlet />
}
